import * as React from "react";
import { useLocation } from "react-router-dom";

const Content = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  
  return (
    <nav aria-label="..." style={{ margin: '1rem', display: "flex", flexDirection: "row-reverse"}}>
      <ul class="pagination">
        <li class="page-item disabled">
          <a class="page-link">Previous</a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#">
            1
          </a>
        </li>
        <li class="page-item active" aria-current="page">
          <a class="page-link" href="#">
            2
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#">
            3
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#">
            Next
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Content;
